export default __webpack_public_path__ + "static/media/03_COMOSS.3ff1c3ee.png";